import React, { useCallback, useState, useRef, useEffect } from 'react';
import { useScreenShare, useDailyEvent } from '@daily-co/daily-react';
import { RecordStartButton, RecordStopButton } from './Icons';
import { recordLocalAtom, isAuthAtom, recordTypeAtom, topMessageAtom } from '../../State';
import { useRecoilState, useSetRecoilState } from 'recoil';
import { useNavigate, useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { ReactComponent as LocalSVG } from '../Images/buttons/localWhite.svg';
import { ReactComponent as CloudSVG } from '../Images/buttons/cloudWhite.svg';
import './Tray.css';
import isElectron from '../../Global';

export default function TrayRecord({ isLive }) {
  //Recoil系
  const [authState, setAuthState] = useRecoilState(isAuthAtom);
  const [recordLocalState, setRecordLocalState] = useRecoilState(recordLocalAtom);
  const [recordType, setRecordTypeState] = useRecoilState(recordTypeAtom);
  const setTopMessageState = useSetRecoilState(topMessageAtom);

  //通常
  const [modeSelectState, setModeSelectState] = useState(false);
  const isCloudRecordFinishedRef = useRef(false);
  const { t } = useTranslation();
  const urlParam = useParams();
  var roomID = urlParam.id; //URL取得

  // 録画開始;
  const startRecording = () => {
    if (recordLocalState) {
      setRecordLocalState(false);
      isCloudRecordFinishedRef.current = true;
    } else {
      selectModeButton();
    }
    // if (isShowCloudRecoding == false) {
    //   if (recordLocalState) {
    //     setRecordLocalState(false);
    //   } else {
    //     setRecordLocalState(true);
    //   }
    // }
  };

  //モード変更ボタン
  const selectModeButton = async () => {
    setModeSelectState(true);
  };

  //モード変更ボタン
  const selectMode = async (mode) => {
    if (mode == 'local') {
      setRecordTypeState('local');
    }

    if (mode == 'cloud') {
      if (authState == false) {
        setTopMessageState({
          type: 'joined',
          message: t('nft.Please login to proceed'),
        });
        return;
      }

      //複数のクラウド録画禁止
      // if (isCloudRecordFinishedRef.current) {
      //   alert(t('bottom.You cannot do multiple cloud recording.'));
      //   return;
      // }

      setRecordTypeState('cloud');
    }

    //録画スタート
    setTimeout(() => {
      setRecordLocalState(true);
    }, 100);

    setModeSelectState(false);
  };

  //背景タップ
  const tapBack = async () => {
    setModeSelectState(false);
  };

  //レンダー
  return (
    <>
      {modeSelectState && (
        <>
          <div id="wrapBack" onClick={tapBack}></div>
          {/* <div id="audioList" className="audioListHairCheck">
            <div id="audioListTitle"> {t('bottom.Select Recording Type')}</div>
            <ul>
              <li
                onClick={(e) => {
                  e.stopPropagation();
                  selectMode('local');
                }}>
                {t('bottom.Start LOCAL recording')}
              </li>

              <li
                onClick={(e) => {
                  e.stopPropagation();
                  selectMode('cloud');
                }}>
                {t('bottom.Start CLOUD recording')}
              </li>
            </ul>
          </div> */}

          <div
            className="extendList"
            style={{ left: '50%', transform: 'translateX(calc(-50% + 195px)' }}>
            <div className="extendMainTitle">{t('call.Save to')}</div>
            <ul className="listExtend">
              <li
                onClick={(e) => {
                  e.stopPropagation();
                  selectMode('local');
                }}>
                <div className="extendImage">
                  <LocalSVG />
                </div>
                <div className="extendText">
                  <div className="extendTitle">{t('call.Save to local')}</div>
                  <div className="extendBody">{t('mypage.Save to your computer directly')}</div>
                </div>
              </li>

              <li
                onClick={(e) => {
                  e.stopPropagation();
                  selectMode('cloud');
                }}>
                <div className="extendImage">
                  <CloudSVG />
                </div>
                <div className="extendText">
                  <div className="extendTitle"> {t('call.Save to cloud')}</div>
                  <div className="extendBody">{t('mypage.Save to cloud & Generate URL')}</div>
                </div>
              </li>
            </ul>
          </div>
        </>
      )}
      <button onClick={startRecording}>
        {recordLocalState ? <RecordStopButton /> : <RecordStartButton />}
      </button>
    </>
  );
}
